import { createAction } from "typesafe-actions";


export const showError = createAction('SHOWERROR')<string>()
export const hideError = createAction('HIDEERROR')()